import { SET_USER_AUTH0_DATA, CLEAR_USER_DATA, SET_USER_LOADING, SET_USER_SMSCODE, SET_SERVER_AUTH } from "./actions";

export const reducer = (state = { isLoading: false, clientInfo: {}, serverAuthenticated: null }, action) => {
  if (action.type === SET_USER_AUTH0_DATA) {
    return { ...state, clientInfo: action.payload };
  }
  if (action.type === CLEAR_USER_DATA) {
    return { isLoading: false, clientInfo: {}, serverAuthenticated: null };
  }
  if (action.type === SET_USER_LOADING) {
    return { ...state, isLoading: action.payload };
  }
  if (action.type === SET_USER_SMSCODE) {
    return { ...state, smsCode: action.payload };
  }
  if (action.type === SET_SERVER_AUTH) {
    return { ...state, serverAuthenticated: action.payload };
  }
  return state;
};